import { useState } from 'react'

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false)

  function toggle() {
    // track action only on open
    if (!isShowing) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: 'toggleModal'
      })
    }

    setIsShowing(!isShowing)
  }

  return [isShowing, toggle]
}

export default useModal
